import { MAIL_TEMPLATE_ACCESS } from "@/helpers/superAdminPermissionConstant";

export default [
    {
        path: "/super-admin/mail-sending",
        name: "mail-sending",
        component: () => import("@/views/super-admin/mail-sending/MailSendingView.vue"),
        meta: {
          gate: MAIL_TEMPLATE_ACCESS,
          requiresSuperAdmin: true,
          pageTitle: "Mail Sending",
          layout: "super-admin",
        },
      },
  ];
  